/* CLAUDE EDIT (03/08/2026): define <localization-form> — o Shrine desta loja não inclui o JS
   do seletor de país do Dawn. Usado pelo seletor no header (sections/header.liquid). */
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[name="country_code"]');
        this.button = this.querySelector('button.disclosure__button');
        this.panel = this.querySelector('.disclosure__list-wrapper');
        if (!this.button || !this.panel) return;
        this.button.addEventListener('click', (e) => {
          e.preventDefault();
          this.button.getAttribute('aria-expanded') === 'true' ? this.close() : this.open();
        });
        this.addEventListener('keyup', (e) => {
          if (e.code === 'Escape') this.close();
        });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.close();
        });
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.close();
        });
        this.querySelectorAll('a[data-value]').forEach((link) => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.input) this.input.value = link.dataset.value;
            const form = this.querySelector('form');
            if (form) form.submit();
          });
        });
      }
      open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.panel.removeAttribute('hidden');
      }
      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', '');
      }
    }
  );
}
